import script from "./Pure.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pure.vue?vue&type=script&lang=ts&setup=true"

import "./Pure.vue?vue&type=style&index=0&id=1254d206&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1254d206"]])

export default __exports__